<template>
  <div :class="$style.share">
    <div :class="$style.trigger" @click.prevent="active = true"><SvgIcon :svg="ShareSvg" width="22" />{{ buttonLabel }}</div>
    <IModal v-model="active" width="300px">
      <div :class="$style.modalContent">
        <button :class="[$style.button, $style.shareFacebook]" @click.prevent="onClickFacebookButton">
          <span>シェアする</span>
        </button>
        <button :class="[$style.button, $style.shareTwitter]" @click.prevent="onClickTwitterButton">
          <span>Xに投稿する</span>
        </button>
        <button :class="[$style.button, $style.shareLine]" @click.prevent="onClickLineButton">
          <span>LINEで送る</span>
        </button>
        <button :class="[$style.button, $style.shareLink]" @click.prevent="onClickCopyButton">
          <span>リンクをコピー</span>
        </button>
      </div>
    </IModal>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { notification } from '@/js/lib/ui';
import IModal from '@/js/components/molecules/IModal.vue';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import ShareSvg from '@/svgs/vue/share.svg';

const props = withDefaults(
  defineProps<{
    title?: string;
    url?: string;
    buttonLabel?: string;
  }>(),
  {
    title: '',
    url: '',
    buttonLabel: 'シェア',
  },
);
const active = ref(false);
const urlForFacebook = computed(() => {
  const url = 'https://www.facebook.com/sharer/sharer.php';
  const params = new URLSearchParams();

  params.append('u', props.url);

  return `${url}?${params.toString()}`;
});
const urlForTwitter = computed(() => {
  const url = 'https://x.com/intent/tweet';
  const params = new URLSearchParams();

  params.append('url', props.url);
  params.append('related', 'iichi_Japan');
  params.append('via', 'iichi_Japan');

  if (props.title) {
    params.append('text', props.title);
  }

  return `${url}?${params.toString()}`;
});
const urlForLine = computed(() => {
  const url = 'https://social-plugins.line.me/lineit/share';
  const params = new URLSearchParams();

  params.append('url', props.url);

  return `${url}?${params.toString()}`;
});
const onClickFacebookButton = () => {
  window.open(urlForFacebook.value, '', 'width=650,height=450,menubar=no,toolbar=no,scrollbars=yes');
};
const onClickTwitterButton = () => {
  window.open(urlForTwitter.value, '', 'width=650,height=450,menubar=no,toolbar=no,scrollbars=yes');
};
const onClickLineButton = () => {
  window.open(urlForLine.value, '', 'width=650,height=450,menubar=no,toolbar=no,scrollbars=yes');
};
const onClickCopyButton = async () => {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(props.url);
    notification('リンクをコピーしました');
  }
};
</script>

<style module lang="scss">
.share {
  width: 36px;
}

.trigger {
  cursor: pointer;
  font-size: 12px;
  text-align: center;
  transition: opacity 0.3s ease-in-out;

  @media (--sp) {
    font-size: 11px;
  }

  &:hover {
    opacity: 0.8;
  }

  svg {
    display: block;
    fill: #4b4b4b;
    margin: 4px auto;
  }

  span {
    display: block;
  }
}

.modalContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 5px 10px;
}

.button {
  background-color: var(--color-white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  color: #404040;
  cursor: pointer;
  display: block;
  padding-left: 6px;
  position: relative;

  &:hover {
    opacity: 0.8;
    text-decoration: none;
  }

  span {
    display: inline-block;
    height: 38px;
    line-height: 38px;
    padding-left: 26px;
    position: relative;

    &::before {
      display: inline-block;
      font-family: $font-icon;
      font-size: 16px;
      left: 2px;
      position: absolute;
      text-align: center;
      width: 16px;
    }
  }

  &.shareFacebook span::before {
    color: #1877f2;
    content: $icon-facebook;
  }

  &.shareTwitter span::before {
    color: var(--color-black);
    content: $icon-twitter;
  }

  &.shareLine span::before {
    color: #00b900;
    content: $icon-line;
  }

  &.shareLink span::before {
    content: $icon-link;
  }
}
</style>
